var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteAvatar = function SvgInviteAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3A3A3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21110_15794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0469 12.4775V16.1892L18.9644 17.9675",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50781 13.2876V13.2876C10.8294 9.55088 14.93 7.59302 18.6667 8.91461C22.4035 10.2362 24.3613 14.3368 23.0397 18.0735C22.2251 20.3769 20.2945 22.1077 17.9161 22.6668",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 23.5H8.91667V23.5C8.68655 23.5 8.5 23.3135 8.5 23.0833V22.745V22.745C8.50274 21.7824 9.28239 21.0027 10.245 21H13.005V21C13.9676 21.0027 14.7472 21.7824 14.75 22.745V23.0833C14.75 23.3135 14.5635 23.5 14.3333 23.5V23.5V23.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6276 18.9163V18.9163C10.7071 18.9163 9.96093 18.1701 9.96094 17.2497C9.96094 16.3292 10.7071 15.583 11.6276 15.583C12.5455 15.583 13.2906 16.3251 13.2943 17.243V17.243C13.2979 18.1635 12.5547 18.9126 11.6343 18.9163C11.632 18.9163 11.6298 18.9163 11.6276 18.9163L11.6276 18.9163Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21110_15794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
};
export { SvgInviteAvatar as ReactComponent };
export default __webpack_public_path__ + "invite-avatar.svg";